import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { EventDate } from '@arema/components/Classes';
import { fromUnix } from '@arema/components/Util';
import { Icon } from 'react-frontier2';
import API from '../API';

interface SearchDateModalProps{
	eventId: number,
	selected?: number[]
}

var SearchDateModal = (props: SearchCoreProps<EventDate> & SearchDateModalProps)=>{
	var { t } = useTranslation();
	return <SearchCoreModal
		title='Buscar fecha'
		{...props}
		search={false}
		searchData={null}
		onShowLoad={(query, page, page_size)=>{
			return API.getEventDates(props.eventId);
		}}
		pageSize={15}
		table={[
			...(props.selected ? [
				{ name: <Icon name='circle-check' />, key: 'date_id', collapsing: true, render: (v: any, o: any)=><Icon name={props.selected.indexOf(o.date_id)==-1 ? 'circle' : 'circle-check'} solid={props.selected.indexOf(o.date_id)!=-1} /> },
			] : []),
			{ name: 'ID', key: 'date_id', collapsing: true },
			{ name: t('common.date'), key: 'date', render: v=>fromUnix(v).toFormat('dd/MMM/yy HH:mm'), collapsing: true },
			{ name: t('common.venue'), key: 'venue_name' },
			{ name: t('common.city'), key: 'city', collapsing: true },
		]}
	/>
}

export default SearchDateModal;